type ShiftApplicationDetailsProps = {
  label?: string;
  labelValue?: string;
  startTime: string;
  endTime: string;
};

export function ShiftApplicationDetails({
  label,
  labelValue,
  startTime,
  endTime,
}: ShiftApplicationDetailsProps) {
  return (
    <div className="flex justify-between text-txt-primary">
      <div className="flex flex-col gap-1">
        <p className="font-semibold">{label ?? "-"}</p>
        <p className="text-brand-500">{labelValue ?? "-"}</p>
      </div>

      <div className="flex flex-col gap-1">
        <p className="font-semibold">Tijd</p>
        <p className="text-brand-500">
          {startTime} - {endTime}
        </p>
      </div>
    </div>
  );
}
